// extracted by mini-css-extract-plugin
export default {"root":"styles_root__MQJZt","brands":"styles_brands__zC3XM","wideBrands":"styles_wideBrands__kg6C1","brandsMobile":"styles_brandsMobile__vfCAz"};